import React, { Component } from 'react'

export class Percentage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      percent: 0
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.animateCounter(nextProps.value, nextProps.maxValue, nextProps.decimal)
    }
  }

  componentDidMount() {
    this.animateCounter(this.props.value, this.props.maxValue, this.props.decimal)
  }

  animateCounter(value, maxValue, decimal) {
    let val = 0
    let maxVal = Number(Number((value / maxValue) * 100)).toFixed(decimal)
    if (maxVal < 0) maxVal = 0
    else if (maxVal > 100) maxVal = 100
    const interval = setInterval(() => {
      if (val <= maxVal) {
        this.setState({ percent: val.toFixed(decimal) })
        val = val + (500 / maxValue)
      } else {
        this.setState({ percent: maxVal })
        clearInterval(interval)
      }
    }, 2);
  }

  render() {
    return (
      <div className="percentage">
        {this.state.percent}%
      </div>
    )
  }
}

export default Percentage
